export default {"src":"/_next/static/media/videoclass-default-dark.4acaf49a.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};